import { render, staticRenderFns } from "./SpaZen.vue?vue&type=template&id=2c07cf77&scoped=true"
import script from "./SpaZen.vue?vue&type=script&lang=js"
export * from "./SpaZen.vue?vue&type=script&lang=js"
import style0 from "./SpaZen.vue?vue&type=style&index=0&id=2c07cf77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c07cf77",
  null
  
)

export default component.exports